import apiFactory from '../config/api-factory';
import { CategoryMetadata } from '../components/v2/search/http';

interface ChannelSearchMetaFetchResponse {
  categories: CategoryMetadata[];
}

class ChannelSearchMetaService {
  id: string;

  constructor(id: string) {
    this.id = id;
  }

  fetch = async () => {
    return apiFactory.optimus.get<ChannelSearchMetaFetchResponse>(
      `/channels/${this.id}/search/meta`
    );
  };
}

export default ChannelSearchMetaService;
